import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { TelegramProvider } from "../telegram/TelegramProvider";
import { QuizProvider } from "../features/quiz/QuizContext";
import { ErrorBoundary } from "../components/ErrorBoundary";
import { LoadingScreen } from "../components/LoadingScreen";
import { IdentitySync } from "./IdentitySync";
import { WelcomeScreen } from "../screens/WelcomeScreen";
import { QuizScreen } from "../screens/QuizScreen";
import { ResultScreen } from "../screens/ResultScreen";
import { MistakeReviewScreen } from "../screens/MistakeReviewScreen";

const AdminApp = lazy(() => import("../screens/admin/AdminApp"));

/**
 * BrowserRouter, not HashRouter: Telegram Mini Apps place their own launch
 * payload in the URL hash fragment (tgWebAppData/tgWebAppVersion/...).
 * HashRouter also reads location.hash to resolve routes — with a Telegram
 * hash present, no app route ever matched "/", so Routes rendered nothing.
 * Proven via real-device traces (WelcomeScreen never mounted, no error) and
 * reproduced directly by loading the deployed app with a Telegram-shaped
 * hash. BrowserRouter never touches the hash, so it can't collide with it —
 * Telegram's launch payload is left completely untouched for the bridge
 * script to read.
 *
 * HashRouter must never return here — see the permanent regression test in
 * ./telegramHash.test.tsx.
 */
export function App() {
  return (
    <ErrorBoundary>
      <TelegramProvider>
        <IdentitySync />
        <QuizProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<WelcomeScreen />} />
              <Route path="/quiz" element={<QuizScreen />} />
              <Route path="/result" element={<ResultScreen />} />
              <Route path="/mistakes" element={<MistakeReviewScreen />} />
              <Route
                path="/admin/*"
                element={
                  <Suspense fallback={<LoadingScreen />}>
                    <AdminApp />
                  </Suspense>
                }
              />
            </Routes>
          </BrowserRouter>
        </QuizProvider>
      </TelegramProvider>
    </ErrorBoundary>
  );
}
